import { useState, useEffect } from "react";
import { lumi } from "../lib/lumi";
import toast from "react-hot-toast";

export function useAuth() {
  const [user, setUser] = useState(lumi.auth.user);
  const [isAuthenticated, setIsAuthenticated] = useState(lumi.auth.isAuthenticated);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = lumi.auth.onAuthChange(({ isAuthenticated, user }) => {
      setUser(user);
      setIsAuthenticated(isAuthenticated);
    });
    return unsubscribe;
  }, []);

  const signIn = async () => {
    setLoading(true);
    try {
      const { user, accessToken } = await lumi.auth.signIn();
      console.log("User authenticated:", user);
      
      // Display success message with spam warning
      toast.success(
        "Un email avec votre accès vient de vous être envoyé.\n\nℹ️ Pensez à vérifier vos spams si vous ne le trouvez pas.",
        { duration: 6000 }
      );
      
      // Automatically send access code email after first successful login
      try {
        console.log("Triggering access code email delivery...");
        const emailResult = await lumi.functions.invoke('sendAccessCodeEmail', {
          method: 'POST'
        });
        console.log("Access code email delivery result:", emailResult);
      } catch (emailError: any) {
        // Non-blocking: email delivery failure doesn't prevent login
        console.error("Access code email delivery failed (non-critical):", emailError);
      }
      
      // Track first_login event (silent, non-blocking)
      try {
        await lumi.entities.user_events.create({
          userId: user.userId,
          eventType: 'first_login',
          timestamp: new Date().toISOString(),
          metadata: {},
          creator: user.userId,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        });
        console.log("first_login event tracked");
      } catch (trackError) {
        // Silent failure: tracking should never block user experience
        console.error("Failed to track first_login (non-critical):", trackError);
      }
      
      return { user, accessToken };
    } catch (error) {
      console.error("Authentication failed:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const signOut = () => {
    lumi.auth.signOut();
  };

  return {
    user,
    isAuthenticated,
    loading,
    signIn,
    signOut,
  };
}
